export interface Partner {
  id: string;
  name: string;
  address: {
    street: string;
    zip: string;
    city: string;
    country: string; // ISO 3166-1 alpha-2
  };
  position: {
    lat: number;
    lng: number;
  };
  website?: string;
  phone?: string;
  email?: string;
}

export function formatAddress(p: Partner): string {
  return `${p.address.street}, ${p.address.zip} ${p.address.city}`;
}
